// @flow
import {wamTimeouts} from '../constants/wamConstants';
import {pageRefreshOnThorDetect} from '../constants/appsConstants';
import AppsUtil from './AppsUtil';
import platform from 'platform';
import wamClient from '@messaging/bifrost';
// check this.
// check appsutil imports
class ThorConnectionUtil {
	refreshCount: number;
	refreshFun: IntervalID;

	/**
	 * To force Kaizen Experience
	 * @returns {boolean}
	 */
	shouldforceKaizenExperience() {
		return AppsUtil.hasFeature('temp_enable_force_kaizen');
	}
	/**
	 * Returns the AAM plugin installed on the current browser
	 *
	 * @returns AAM Plugin
	 */
	getAAMPlugin() {
		let aamPlugin = null;

		if (navigator && navigator.plugins) {
			aamPlugin = Object.values(navigator.plugins).find(plugin => plugin && plugin.name && plugin.name.toLowerCase().indexOf('adobeaamdetect') > -1);
		}

		if (!aamPlugin && platform.name === 'IE') {
			try {
				aamPlugin = new ActiveXObject('AdobeAAMDetect.AdobeAAMDetect');
			}
			catch (e) {
				return null;
			}
		}

		return aamPlugin;
	}

	/**
	 * Returns the version of the AAM plugin installed on the current browser
	 *
	 * @returns AAM Plugin version
	 */
	getAAMPluginVersion() {
		let aamVersion = null;
		let aamPlugin = null;
		// Win: Creative Cloud Desktop Plugin.v_2_0_0_0
		// Mac: A plugin to detect whether the Adobe Creative Cloud is installed on this machine.v_2_0_0_0
		if (navigator && navigator.plugins) {
			aamPlugin = Object.values(navigator.plugins).find(plugin => plugin && plugin.name && typeof plugin.name === 'string' && plugin.name.toLowerCase().indexOf('adobeaamdetect') > -1);

			// Retrieve version info from description
			if (aamPlugin && aamPlugin.description) {
				aamVersion = aamPlugin.description.match(/[0-9]_[0-9]_[0-9]_[0-9]/i);
				if (aamVersion && aamVersion[0]) {
					aamVersion = aamVersion[0].replace(/_/g, '.');
				}
			}
		}

		// Win IE: x.0.0.0
		if (!aamPlugin && platform.name === 'IE') {
			try {
				aamPlugin = new ActiveXObject('AdobeAAMDetect.AdobeAAMDetect');
				if (aamPlugin && aamPlugin.version) {
					aamVersion = aamPlugin.version.match(/[0-9].[0-9].[0-9].[0-9]/i);
					if (aamVersion && aamVersion[0]) {
						aamVersion = aamVersion[0];
					}
				}
			}
			catch (e) {
				return null;
			}
		}

		return aamVersion;
	}

	/**
	 * Tells whether the aamPlugin supports URL schema: aam://adobecreativecloud/?SAPCode=LTRM&version=5.6&actionList=CCPP
	 * which is provided by FFC on the cc-uri parameter. Versions 3.0.0.0 and above of Thor support this schema
	 *
	 * @returns true or false
	 */
	aamPluginSupportsCCURI() {
		const aamVersion = this.getAAMPluginVersion();
		const ccURISupportVersion = '3.0.0.0';
		return (aamVersion && window.cchome.util.compareVersionNumbers(aamVersion, ccURISupportVersion) >= 0); // TODO
	}

	/**
	 * Tells whether the aamPlugin supports '&'. Versions 3.0.0.0 and above of Thor support using '&' to separate
	 * parameters passed on the URL, just like http
	 *
	 * @returns true or false
	 */
	aamPluginSupportsAmpersand() {
		const aamVersion = this.getAAMPluginVersion();
		const ampersandSupportVersion = '3.0.0.0';
		return (aamVersion && window.cchome.util.compareVersionNumbers(aamVersion, ampersandSupportVersion) >= 0); // TODO
	}

	/**
	 * Returns the promise that detects whether Thor is installed or not
	 *
	 * @returns Promise
	 */
	checkForThor(): Promise<boolean> {
		// fail thor detection if Kaizen expereince is forced
		if (this.shouldforceKaizenExperience() || AppsUtil.isMobileOrTab()) {
			return new Promise((resolve) => {
				resolve(false);
			});
		}
		if (AppsUtil.isFFCFallback) { // TODO
			return new Promise((resolve) => {
				resolve(false);
			});
		}
		return wamClient.checkForCCD(window.ENV);
	}

	// Redirects to home page when CCD is detected
	refreshToHome(wamConnectCallback: Function, loadHomePageCallback: Function, redirectionAnalyticsCallback: Function, shouldBypassTest: boolean) {
		redirectionAnalyticsCallback();
		if (!AppsUtil.hasThor && shouldBypassTest) {
			if (!this.refreshFun) {
				this.refreshCount = 0;
				const divider = 2;
				const nextIterations = pageRefreshOnThorDetect.nextIterationsOneDay;
				this.refreshFun = setInterval(() => {
					if (this.refreshCount < pageRefreshOnThorDetect.iterations || this.refreshCount % divider === 0) {
						this.checkForThor().then((isThorPresent) => {
							if (isThorPresent) {
								clearInterval(this.refreshFun);
								wamConnectCallback({timeout: wamTimeouts.thorConnectionTimeoutOnPageLoad, sendAnalytics: false, retryWAMConnection: true});
								if (AppsUtil.isPostPurchaseUser() || shouldBypassTest) {
									loadHomePageCallback();
								}
							}
							else {
								if (this.refreshCount >= nextIterations) {
									clearInterval(this.refreshFun);
								}
							}
						});
					}
					this.refreshCount++;
				}, pageRefreshOnThorDetect.interval);
			}
		}
	}
}

export default new ThorConnectionUtil();
